export function ErrorMessageComponent({ error }: { error: string }) {
  return (
    <div className='flex min-h-[400px] flex-col items-center justify-center rounded-md border border-dashed p-8 text-center animate-in fade-in-50'>
      <div className='mx-auto flex max-w-[420px] flex-col items-center justify-center text-center'>
        <h1 className='h'>Oops!</h1>
        <p>Sorry, an unexpected error has occurred.</p>
        <p>
          <strong>Error:</strong> <i>{error}</i>
        </p>
      </div>
    </div>
  );
}
